import { VTemplate } from "../../entity/Store";

export interface VThemeTemplate {
  id: string;
  name: string;
  key?: string;
  displayWeb: string;
  displayMobile: string;
  primaryColor: string;
  secondaryColor: string;
  isSelectable: boolean;
  isCamingSoon?: boolean;
  logo?: string;
  previewUrl?: string;
}

export const ThemeTemplate: VThemeTemplate[] = [
  {
    id: "1",
    name: "Valencia",
    key: VTemplate.VALENCIA,
    displayWeb:
      "https://amzn-s3-vednora-bucket.s3.eu-north-1.amazonaws.com/static/6a05aacb3ce1975e20077a14.jpg",
    displayMobile:
      "https://amzn-s3-vednora-bucket.s3.eu-north-1.amazonaws.com/static/6a05ab2472c70066f77ed421.jpg",
    primaryColor: "#000000",
    secondaryColor: "#ffffff",
    isSelectable: true,
    previewUrl:
      "https://foryoustore.vendora-shop.online?preview=true&theme=valencia",
  },
  {
    id: "2",
    isCamingSoon: false,
    name: "Rio",
    key: VTemplate.RIO,
    displayWeb:
      "https://amzn-s3-vednora-bucket.s3.eu-north-1.amazonaws.com/static/rio.jpg",
    displayMobile:
      "https://amzn-s3-vednora-bucket.s3.eu-north-1.amazonaws.com/static/rio.jpg",
    logo: "/path/to/dark-logo.png",
    primaryColor: "#000000",
    secondaryColor: "#ffffff",
    isSelectable: false,
    previewUrl:
      "https://foryoustore.vendora-shop.online?preview=true&template=rio",
  },
  {
    id: "3",
    name: "Dakar",
    key: VTemplate.DAKAR,
    isCamingSoon: false,

    logo: "/path/to/light-logo.png",
    primaryColor: "#000000",
    secondaryColor: "#ffffff",
    displayWeb:
      "https://amzn-s3-vednora-bucket.s3.eu-north-1.amazonaws.com/static/dakar.jpg",
    displayMobile:
      "https://amzn-s3-vednora-bucket.s3.eu-north-1.amazonaws.com/static/dakar.jpg",
    isSelectable: false,
    previewUrl:
      "https://foryoustore.vendora-shop.online?preview=true&template=dakar",
  },

  {
    id: "3",
    name: "Dakar",
    isCamingSoon: true,

    logo: "/path/to/light-logo.png",
    primaryColor: "#000000",
    secondaryColor: "#ffffff",
    displayWeb: "",
    displayMobile: "",
    isSelectable: false,
    previewUrl:
      "https://foryoustore.vendora-shop.online?preview=true&template=dakar",
  },
];
